import { combineReducers } from "redux";
import userGroupsReducer from "./userGroups/reducer";

const userProfileReducer = combineReducers({
  userGroups: userGroupsReducer
});

export default userProfileReducer;
